export default __webpack_public_path__ + "static/media/tasting-thumb.a6abed0f.jpg";